import _ from "lodash";
import envconfig from "@/config/EnvConfig";

export default class ProductUtil {
    static qrcode(productKey: string, productNatureKey: string, activeCode: string) {
        const params = {
            activeCode: activeCode,
            productKey: productKey,
            productNatureKey: productNatureKey
        }
        let qrcode = envconfig.wx.oa.url + "?"

        for (const [key, value] of Object.entries(params)) {
            qrcode = `${qrcode}${key}=${value}&`
        }
        qrcode = _.trimEnd(qrcode, "&")
        return qrcode
    }
}
